<template>
  <div class="icon"
       :class="iconClass"
       v-html="require('!svg-inline-loader?classPrefix!../assets/icons/' + iconName + '.svg')"></div>
</template>

<script>
  export default {
    name: 'Icon',
    props: ['iconName', 'iconClass']
  }
</script>
